import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { MAILING_SETTINGS_API } from '../api/mailing-settings-api';
export const useSubstituteEmails = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [`${MAILING_SETTINGS_API}/substitute-email`, RequestModuleEnum.UserEmail];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[2] !== data) {
    t2 = Array.isArray(data) ? {} : data;
    $[2] = data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      substituteEmails: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};